import {Pipe, PipeTransform} from '@angular/core';
import * as _ from 'lodash';

@Pipe({ name: 'message' })
export class MessagePipe implements PipeTransform {
  transform(value: { [key: string]: string }, lang: string): string { return _.get(value, lang); }
}
